@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.config-step-body {
  margin-top: @space-16;
}

.mapping-list-wrapper {
  width: 50%;
}

.update-checkbox {
  margin-top: @space-8;
  margin-bottom: @space-24;
}
